// extracted by mini-css-extract-plugin
module.exports = {"fallbackParent":"FallBackStyle_fallbackParent__3xj-6","headingStyles":"FallBackStyle_headingStyles__2m4xH"};